<template>
  <v-card elevation="1" class="secondary__table">
    <v-data-table
      :headers="myHeaders"
      :items="items"
      :item-key="itemKey"
      :single-select="singleSelect"
      :loading-text="loadingText"
      :dense="dense"
      :no-data-text="noDataText"
      :page.sync="page"
      :items-per-page="limit"
      :custom-filter="customFilter"
      :show-select="showSelect"
      :loading="loading"
      @click:row="rowClickEvent"
      hide-default-footer
      :options.sync="optionsObj"
      :sortBy.sync="sortAr"
      v-model="selectedItems"

      mobile-breakpoint="990"
      :item-class="itemRowBackground"
      :fixed-header="true"
      :height="heightOfTableresult"
    >
<!-- height="560"-->

      <template slot="top" slot-scope="scope">
        <slot name="top" v-bind="scope" />
      </template>
      <!-- eslint-disable-next-line -->
      <template v-for="field in headers" :v-sticky="1" :slot="slotName(field)" slot-scope="scope">
        <slot class="ma-0 pa-0 font-weight-bold" :name="slotName(field)" v-bind="scope">{{
          scope.item[field.value]
        }}</slot>
      </template>

      <template slot="top" slot-scope="scope">
        <slot name="top" v-bind="scope" />
      </template>
      <!-- eslint-disable-next-line -->
      <template v-for="field in headers" :v-sticky="1" :slot="slotName(field)" slot-scope="scope">
        <slot class="ma-0 pa-0 font-weight-bold" :name="slotName(field)" v-bind="scope"
          >{{ scope.item[field.value] }}
        </slot>
      </template>

      <!-- <template v-slot:footer>
        <v-divider />

        <v-toolbar flat class="table-toolbar">
          <v-btn icon color="primary" class="mr-3" width="35px" @click="refresh">
            <v-icon style="color: white !important">mdi-refresh</v-icon>
          </v-btn>
          <p style="margin: 0 12px 7px 12px">عدد الصفوف في الصفحة الواحدة</p>

          <v-text-field
            outlined
            v-model="per_page_count"
            dense
            width="10"
            height="35"
            color="purple"
            class="pruple-border"
            style="min-width: unset; max-width: 60px !important"
          ></v-text-field>
          <v-btn icon color="primary" class="mr-3" width="35px" v-if="$store.state.counterOfShow != per_page_count" @click="$store.state.counterOfShow = parseInt(per_page_count)">
            <v-icon style="color: white !important">mdi-check</v-icon>
          </v-btn>
          <span class="font-italic mr-2" style="position: absolute; right: 50%">
            صفحه {{ page }}
            <span v-if="pagination != null"
              >من {{ pages }}, إجمالي البيانات {{ results }}</span
            >
          </span>
          <v-spacer></v-spacer>
          <div style="margin: 0 0 20px 20px">
            <v-btn
              text
              small
              color="primary"
              :disabled="page == 1 || loading"
              @click="page--"
            >
              <v-icon left style="color: white !important; margin-right: 5px"
                >mdi-arrow-right</v-icon
              >
            </v-btn>
            <v-btn
              text
              small
              color="primary"
              :disabled="
                loading || pagination ? page == pages : false || items.length < limit
              "
              @click="page++"
            >
              <v-icon right style="margin-left: 5px; color: white !important"
                >mdi-arrow-left</v-icon
              >
            </v-btn>
          </div>
        </v-toolbar>
      </template> -->

      <template v-slot:footer>
        <v-divider />
        <v-toolbar flat class="table-toolbar">
          <div style="display: flex; align-items: center; position: absolute;">
            <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="8"
              @input="handlePageChange"
              color="primary"
              square
    
            ></v-pagination>
            <v-text-field
              outlined
              :value="tempCounterOfShow"
              @input="updateTempCounterOfShow"
              @blur="updateCounterOfShow"
              dense
              width="10"
              height="25"
              color="purple"
              class="pruple-border"
              style="min-width: unset; max-width: 60px !important; right: 2%; margin-top: 10px;"
            ></v-text-field>
          </div>
          <span class="font-italic mr-2" style="display: flex; align-items: center; position: absolute;left: 2%;">
            صفحه {{ page }}
            <span v-if="pagination != null"
              >من {{ pages }}, إجمالي البيانات {{ results }}</span
            >
          </span>
        </v-toolbar>
      </template>
      
      <!-- eslint-disable -->
      <template v-slot:item.data-table-select="{ item, isSelected, select }">
        <v-simple-checkbox
          :value="isSelected"
          @input="select($event)"
        ></v-simple-checkbox>
      </template>

      <template   :v-sticky="1" v-slot:[`body.append`]="{ items }" v-if="returnDailyReportPlace">
        <tr>
          <td style="margin-right: 17px">#</td>
          <td style="margin-right: 17px">المجموع</td>
          <td
            v-if="
              headers.findIndex((res) => res.value === 'مجموع الطلبات المستلمة') !== -1
            "
          >
            {{ calculateTotal(items, "مجموع الطلبات المستلمة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المستلمة') !== -1">
            {{ calculateTotal(items, "المستلمة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المميزة') !== -1">
            {{ calculateTotal(items, "المميزة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المتابعة') !== -1">
            {{ calculateTotal(items, "المتابعة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المؤرشفة') !== -1">
            {{ calculateTotal(items, "المؤرشفة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المرسلة') !== -1">
            {{ calculateTotal(items, "المرسلة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المكتملة') !== -1">
            {{ calculateTotal(items, "المكتملة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المحدث عليها') !== -1">
            {{ calculateTotal(items, "المحدث عليها") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'تم فتحها') !== -1">
            {{ calculateTotal(items, "تم فتحها") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المهام المستلمة') !== -1">
            {{ calculateTotal(items, "المهام المستلمة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المهام المرسلة') !== -1">
            {{ calculateTotal(items, "المهام المرسلة") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'التذكيرات') !== -1">
            {{ calculateTotal(items, "التذكيرات") }}
          </td>
          <td
            v-if="headers.findIndex((res) => res.value === 'الطلبات المحولة منه') !== -1"
          >
            {{ calculateTotal(items, "الطلبات المحولة منه") }}
          </td>
          <td
            v-if="headers.findIndex((res) => res.value === 'الطلبات المحولة إليه') !== -1"
          >
            {{ calculateTotal(items, "الطلبات المحولة إليه") }}
          </td>
          <td v-if="headers.findIndex((res) => res.value === 'المستقبلة - المحولة منه') !== -1">
            {{ calculateTotal(items, "المستقبلة - المحولة منه") }}
          </td>
          <td></td>
        </tr>
      </template>
      <template  :v-sticky="1" v-slot:[`body.append`]="{ items }" v-else-if="returnProductivity">
        <tr style="font-weight: bold;">
          <td class="td text-center" style="margin-right: 17px;">المجموع</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'المستقبلة')">{{ dataVal.total_recived_request_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قبول أولي')">{{ dataVal.followed_basket_possible_to_sell_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'المتابعه')">{{ dataVal.possible_to_sell_to_customer_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'المتابعه%')">{{ dataVal.followed_basket_possible_to_sell_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه مبيعات')">{{ dataVal.sent_basket_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضه مبيعات')">{{ dataVal.sent_basket_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'المبيعات%')">{{ dataVal.sent_basket_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه تمويل')">{{ dataVal.sent_basket_funding_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضة تمويل')">{{ dataVal.sent_basket_funding_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قائم تمويل')">{{ dataVal.waiting_fm_status_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'التمويل%')">{{ dataVal.sent_basket_funding_send_basket_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه رهن')">{{ dataVal.sent_basket_mortgage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضة رهن')">{{ dataVal.sent_basket_mortgage_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قائم رهن')">{{ dataVal.waiting_mm_status_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'الرهن%')">{{ dataVal.sent_basket_mortgage_reject_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مفرغة')">{{ dataVal.completed_request_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%مفرغة')">{{ dataVal.completed_request_percentage_sum }}</td>
        </tr>
      </template>
      <template  :v-sticky="1" v-slot:[`body.append`]="{ items }" v-else-if="returnProductivityV2">
        <tr style="font-weight: bold">
          <td class="td text-center" style="margin-right: 17px">المجموع</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'المستقبلة') !== -1">{{ dataVal.total_recived_request_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قبول أولي') !== -1">{{ dataVal.followed_basket_possible_to_sell_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'المتابعه') !== -1">{{ dataVal.possible_to_sell_to_customer_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%المتابعه') !== -1">{{ dataVal.followed_basket_possible_to_sell_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه مبيعات') !== -1">{{ dataVal.sent_basket_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضه مبيعات') !== -1">{{ dataVal.sent_basket_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%مبيعات') !== -1">{{ dataVal.sent_basket_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه تمويل') !== -1">{{ dataVal.sent_basket_funding_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضة تمويل') !== -1">{{ dataVal.sent_basket_funding_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قائم تمويل') !== -1">{{ dataVal.waiting_fm_status_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%تمويل') !== -1">{{ dataVal.sent_basket_mortgage_send_basket_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه رهن') !== -1">{{ dataVal.sent_basket_mortgage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضة رهن') !== -1">{{ dataVal.sent_basket_mortgage_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قائم رهن') !== -1">{{ dataVal.waiting_mm_status_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%رهن') !== -1">{{ dataVal.sent_basket_funding_send_basket_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مفرغة') !== -1">{{ dataVal.completed_request_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%مفرغة') !== -1">{{ dataVal.completed_request_percentage_sum }}</td>
        </tr>
      </template>
      <template  :v-sticky="1" v-slot:[`body.append`]="{ items }" v-else-if="returnProductivityV3">
        <tr style="font-weight: bold">
          <td class="td text-center" style="margin-right: 17px">المجموع</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'المستقبلة') !== -1">{{ dataVal.total_recived_request_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قبول أولي') !== -1">{{ dataVal.followed_basket_possible_to_sell_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'المتابعه') !== -1">{{ dataVal.possible_to_sell_to_customer_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%المتابعه') !== -1">{{ dataVal.followed_basket_possible_to_sell_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه مبيعات') !== -1">{{ dataVal.sent_basket_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضه مبيعات') !== -1">{{ dataVal.sent_basket_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%مبيعات') !== -1">{{ dataVal.sent_basket_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه تمويل') !== -1">{{ dataVal.sent_basket_funding_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضة تمويل') !== -1">{{ dataVal.sent_basket_funding_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قائم تمويل') !== -1">{{ dataVal.waiting_fm_status_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%تمويل') !== -1">{{ dataVal.sent_basket_mortgage_send_basket_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه رهن') !== -1">{{ dataVal.sent_basket_mortgage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوضة رهن') !== -1">{{ dataVal.sent_basket_mortgage_reject_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قائم رهن') !== -1">{{ dataVal.waiting_mm_status_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%رهن') !== -1">{{ dataVal.sent_basket_funding_send_basket_percentage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مفرغة') !== -1">{{ dataVal.completed_request_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === '%مفرغة') !== -1">{{ dataVal.completed_request_percentage_sum }}</td>
        </tr>
      </template>
      <template  :v-sticky="1" v-slot:[`body.append`]="{ items }" v-else-if="returnMortgageReport">
        <tr style="font-weight: bold">
          <td class="td text-center" style="margin-right: 17px">المجموع</td>

          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'مرفوعه رهن') !== -1">{{ dataVal.sent_basket_mortgage_sum }}</td>
          <td class="td text-center" v-if="headers.findIndex((res) => res.value === 'قائم رهن') !== -1">{{ dataVal.waiting_mm_status_sum }}</td>
        </tr>
      </template>
      <template  :v-sticky="1" v-slot:[`body.append`]="{ items }" v-else-if="returnRequestSources">
       <tr class="request-sources-summary-row" style="font-weight: bold">
         <td class="td text-center" v-for="(val,key) in sum_of_each_source"  v-if="headers.findIndex((res) => res.value === key) !== -1">{{ val }}</td>
       </tr>
        <tr class="request-sources-summary-row">
          <td class="td text-center" v-for="(dub,key) in duplicatedLogin"  v-if="headers.findIndex((res) => res.value === key) !== -1">{{ dub }}</td>
        </tr>
        <tr class="request-sources-summary-row">
          <td class="td text-center" v-for="(dub,key) in new_sum_of_each_source"  v-if="headers.findIndex((res) => res.value === key) !== -1">{{ dub }}</td>
        </tr>
      </template>

      <template  :v-sticky="1" v-slot:[`body.append`]="{ items }" v-else-if="returnDuplicatedRegister">
        <tr style="font-weight: bold;">
          <td class="td text-right" colspan="2" style="padding-right: 80px;">المجموع</td>
          <td class="td text-right" v-if="headers.findIndex((res) => res.value === 'عدد محاولات التسجيل')">{{ sum_of_duplicated_register }}</td>
        </tr>
      </template>


    </v-data-table>
  </v-card>
</template>

<script>
import Axios from "axios";
import ProductivityReportFilter from "@/views/admin/Charts/ProductivityReportFilter";

export default {
  name: "SecondaryTableComponent",
  props: {
    dense: { default: false },
    pagination: { default: null },
    sum_of_duplicated_register: { default: null },
    value: { default: 1 },
    limit: { default: 12 },
    headers: { required: true },
    formBody: { default: undefined },
    itemKey: { default: undefined },
    singleSelect: { default: false },
    showSelect: { default: false },
    items: { required: true },
    loading: { default: false },
    children: { type: Array },
    rowClickEvent: {
      type: Function,
      default: () => {},
    },
    loadingText: { default: "جاري تحميل البيانات ..." },
    noDataText: { default: "لا توجد بيانات" },
    selectedRows: { type: Array },
    customFilter: {
      default: () => {},
    },
    options: { required: false },
    sortBy: { required: false },
  },
  data() {
    return {
      per_page_count: 10,
      selectedItems: [],
      duplicatedLogin: [],
      sum_of_each_source: [],
      new_sum_of_each_source: [],
      body: {},
      dataVal: {
        total_recived_request_sum: 0,
        followed_basket_possible_to_sell_sum: 0,
        followed_basket_possible_to_sell_percentage_sum: 0,
        completed_request_sum: 0,
        completed_request_percentage_sum: 0,
        waiting_mm_status_sum: 0,
        waiting_fm_status_sum: 0,
        possible_to_sell_to_customer_sum: 0,

        sent_basket_sum: 0,
        sent_basket_reject_sum: 0,
        sent_basket_reject_percentage_sum: 0,
        sent_basket_percentage_sum: 0,

        sent_basket_funding_sum: 0,
        sent_basket_funding_reject_sum: 0,
        sent_basket_funding_reject_percentage_sum: 0,
        sent_basket_funding_percentage_sum: 0,

        sent_basket_mortgage_sum: 0,
        sent_basket_funding_send_basket_percentage_sum: 0,
        sent_basket_mortgage_send_basket_percentage_sum: 0,
        sent_basket_mortgage_reject_sum: 0,
        sent_basket_mortgage_percentage_sum: 0,
        sent_basket_mortgage_reject_percentage_sum: 0,
      },

      newOrderId: null,
      tempCounterOfShow: this.$store.state.counterOfShow,
    };
  },
  watch: {
    "$store.state.orderRequestId": {
      // immediate: true,
      handler(newOrderId, oldOrderId) {
        if (newOrderId) {
          this.itemRowBackground(this.newOrderId);
        }
      },
    },
    selectedItems(newlySelectedRows) {
      this.$emit("update:selectedRows", newlySelectedRows);
    },
    page(val) {
      this.$emit("update:page", val);
    },
    limit() {
      if (this.pagination != null) {
        return this.pagination.limit;
      }
      return 10;
    },
    "$store.state.tasksRequestId": {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.itemRowBackground(this.newOrderId);
        }
      },
    },

    "$store.state.tasksDetailsRequestId": {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.itemRowBackground(this.newOrderId);
        }
      },
    },
  },
  computed: {

    heightOfTableresult(){
      if(this.$store.state.counterOfShow > 10){
        return "600";
      }else{
        return "";
      }
    },

    returnDailyReportPlace() {
      return (
        window.location.pathname === "/salesManager/chart/dailyPerformance" ||
        window.location.pathname === "/admin/charts/dailyPerformance" ||
        window.location.pathname === "/admin/charts"
      );
    },
    returnProductivity() {
      return (
        window.location.pathname === "/admin/charts/productivity"
      );
    },
    returnProductivityV2() {
      return (
        window.location.pathname === "/admin/charts/productivity-v2"||
        window.location.pathname === "/salesManager/charts/productivity-report"
      );
    },
    returnProductivityV3() {
      return (
        window.location.pathname === "/admin/charts/productivity-v3"
      );
    },
    returnMortgageReport() {
      return (
          window.location.pathname === "/admin/charts/mortgage-report"
      );
    },
    returnRequestSourcesSales() {
      return (
        window.location.pathname === "/salesManager/charts/requests-sources"
      );
    },
    returnRequestSources() {
      return (
        window.location.pathname === "/admin/charts/requests-sources"
      );
    },

    returnDuplicatedRegister() {
      return (
        window.location.pathname === "/salesManager/chart/duplicated-register"
      );
    },

    page: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    sortAr: {
      get() {
        return this.sortBy;
      },
      set(val) {
        this.$emit("update:sortBy", val);
      },
    },
    optionsObj: {
      get() {
        return this.options;
      },
      set(val) {
        this.$emit("update:options", val);
      },
    },
    results() {
      return this.pagination.count;
    },
    pages() {
      return Math.ceil(parseInt(this.pagination?.count) / parseInt(this.limit)) || 1;
      // return Math.ceil(parseInt(this.pagination['count']) / parseInt(this.limit)) || 1
    },
    myHeaders: {
      get: function () {
        let headers = [];
        headers = this.headers;
        !this.headers.some((item) => item.value === "data-table-select") &&
        this.showSelect
          ? headers.unshift({
              align: "start",
              value: "data-table-select",
              width: "5%",
            })
          : "";
        return headers;
      },
    },
  },
  methods: {
    handlePageChange(value) {
      this.page = value;
    },
    
    calculateSumSources() {
      let url = `${this.$store.state.url}/employee/admin/request-sources-sums`;
      Axios.post(url, this.formBody, { headers: this.request_headers() }).then((res) => {

        this.sum_of_each_source=res.data.payload.sum_of_each_source;
        this.duplicatedLogin=res.data.payload.duplicatedLogin;
        this.new_sum_of_each_source=res.data.payload.new_sum_of_each_source;
      });
    },
    calculateSum() {
      let url = `${this.$store.state.url}/employee/admin/getProductivitySumAgents`;
      Axios.post(url, this.formBody, { headers: this.request_headers() }).then((res) => {
        this.dataVal.total_recived_request_sum =
          res.data.payload.total_recived_request_sum;
        this.dataVal.sent_basket_sum = res.data.payload.sent_basket_sum;
        this.dataVal.completed_request_sum = res.data.payload.completed_request_sum;
        this.dataVal.sent_basket_mortgage_sum = res.data.payload.sent_basket_mortgage_sum;
        this.dataVal.sent_basket_reject_sum = res.data.payload.sent_basket_reject_sum;
        this.dataVal.sent_basket_funding_reject_sum =
          res.data.payload.sent_basket_funding_reject_sum;
        this.dataVal.sent_basket_funding_sum = res.data.payload.sent_basket_funding_sum;
        this.dataVal.waiting_mm_status_sum = res.data.payload.waiting_mm_status_sum;
        this.dataVal.waiting_fm_status_sum = res.data.payload.waiting_fm_status_sum;
        this.dataVal.possible_to_sell_to_customer_sum = res.data.payload.possible_to_sell_to_customer_sum;
        this.dataVal.sent_basket_mortgage_reject_sum =
          res.data.payload.sent_basket_mortgage_reject_sum;
        this.dataVal.followed_basket_possible_to_sell_sum =
          res.data.payload.followed_basket_possible_to_sell_sum;
        this.dataVal.sent_basket_percentage_sum =
          res.data.payload.sent_basket_percentage_sum + "%";
        this.dataVal.sent_basket_percentage_sum =
          res.data.payload.sent_basket_percentage_sum + "%";
        this.dataVal.sent_basket_funding_percentage_sum =
          res.data.payload.sent_basket_funding_percentage_sum + "%";
        this.dataVal.sent_basket_mortgage_percentage_sum =
          res.data.payload.sent_basket_mortgage_percentage_sum + "%";
        this.dataVal.sent_basket_reject_percentage_sum =
          res.data.payload.sent_basket_reject_percentage_sum + "%";
        this.dataVal.sent_basket_funding_reject_percentage_sum =
          res.data.payload.sent_basket_funding_reject_percentage_sum + "%";
        this.dataVal.sent_basket_mortgage_reject_percentage_sum =
          res.data.payload.sent_basket_mortgage_reject_percentage_sum + "%";
        this.dataVal.sent_basket_funding_send_basket_percentage_sum =
            res.data.payload.sent_basket_funding_send_basket_percentage_sum + "%";

        this.dataVal.sent_basket_mortgage_send_basket_percentage_sum =
            res.data.payload.sent_basket_mortgage_send_basket_percentage_sum + "%";

        this.dataVal.followed_basket_possible_to_sell_percentage_sum =
            res.data.payload.followed_basket_possible_to_sell_percentage_sum + "%";
        this.dataVal.completed_request_percentage_sum =
          res.data.payload.completed_request_percentage_sum + "%";
      });
    },
    calculateSumV3() {
      let url = `${this.$store.state.url}/employee/admin/getProductivitySum`;
      Axios.post(url, this.formBody, { headers: this.request_headers() }).then((res) => {
        this.dataVal.total_recived_request_sum =
            res.data.payload.total_recived_request_sum;
        this.dataVal.sent_basket_sum = res.data.payload.sent_basket_sum;
        this.dataVal.completed_request_sum = res.data.payload.completed_request_sum;
        this.dataVal.sent_basket_mortgage_sum = res.data.payload.sent_basket_mortgage_sum;
        this.dataVal.sent_basket_reject_sum = res.data.payload.sent_basket_reject_sum;
        this.dataVal.sent_basket_funding_reject_sum =
            res.data.payload.sent_basket_funding_reject_sum;
        this.dataVal.sent_basket_funding_sum = res.data.payload.sent_basket_funding_sum;
        this.dataVal.waiting_mm_status_sum = res.data.payload.waiting_mm_status_sum;
        this.dataVal.waiting_fm_status_sum = res.data.payload.waiting_fm_status_sum;
        this.dataVal.possible_to_sell_to_customer_sum = res.data.payload.possible_to_sell_to_customer_sum;
        this.dataVal.sent_basket_mortgage_reject_sum =
            res.data.payload.sent_basket_mortgage_reject_sum;
        this.dataVal.followed_basket_possible_to_sell_sum =
            res.data.payload.followed_basket_possible_to_sell_sum;
        this.dataVal.sent_basket_percentage_sum =
            res.data.payload.sent_basket_percentage_sum + "%";
        this.dataVal.sent_basket_percentage_sum =
            res.data.payload.sent_basket_percentage_sum + "%";
        this.dataVal.sent_basket_funding_percentage_sum =
            res.data.payload.sent_basket_funding_percentage_sum + "%";
        this.dataVal.sent_basket_mortgage_percentage_sum =
            res.data.payload.sent_basket_mortgage_percentage_sum + "%";
        this.dataVal.sent_basket_reject_percentage_sum =
            res.data.payload.sent_basket_reject_percentage_sum + "%";
        this.dataVal.sent_basket_funding_reject_percentage_sum =
            res.data.payload.sent_basket_funding_reject_percentage_sum + "%";
        this.dataVal.sent_basket_mortgage_reject_percentage_sum =
            res.data.payload.sent_basket_mortgage_reject_percentage_sum + "%";
        this.dataVal.sent_basket_funding_send_basket_percentage_sum =
            res.data.payload.sent_basket_funding_send_basket_percentage_sum + "%";

        this.dataVal.sent_basket_mortgage_send_basket_percentage_sum =
            res.data.payload.sent_basket_mortgage_send_basket_percentage_sum + "%";

        this.dataVal.followed_basket_possible_to_sell_percentage_sum =
            res.data.payload.followed_basket_possible_to_sell_percentage_sum + "%";
        this.dataVal.completed_request_percentage_sum =
            res.data.payload.completed_request_percentage_sum + "%";
      });
    },
    calculateMortgageSum() {
      let url = `${this.$store.state.url}/employee/admin/getMortgageSumAgents`;
      Axios.post(url, this.formBody, { headers: this.request_headers() }).then((res) => {

        this.dataVal.sent_basket_mortgage_sum = res.data.payload.sent_basket_mortgage_sum;
        this.dataVal.waiting_mm_status_sum = res.data.payload.waiting_mm_status_sum;
      });
    },

    calculateTotal(items, column) {
      let total = 0;
      for (const item of items) {
        total += item[column];
      }
      return total;
    },
    itemRowBackground(res) {
      this.newOrderId = res;
      const isStatusOpenRequest =
        res.status === "طلب تم فتحه" &&
        !res.comment &&
        !res.class_id_agent_text &&
        window.location.pathname.includes("/agent");

      const isMatchingPath =
        (res.request?.id === this.$store.state.orderRequestId ||
          res.id === this.$store.state.orderRequestId ||
          res.request_id === this.$store.state.orderRequestId) &&
        (window.location.pathname.includes("/admin") ||
          window.location.pathname.includes("/salesManager")) &&
        (this.$store.state.openOrderRequestSection ||
          this.$store.state.orderRequestDialog);

      const isMatchingRequestTasksPath =
        (res.request?.id === this.$store.state.tasksRequestId ||
          res.id === this.$store.state.tasksRequestId ||
          res.request_id === this.$store.state.tasksRequestId) &&
        window.location.pathname.includes("/admin") &&
        this.$store.state.openTasksRequestSection;

      const isMatchingRequestTasksDetailsPath =
        (res.request?.id === this.$store.state.tasksDetailsRequestId ||
          res.id === this.$store.state.tasksDetailsRequestId ||
          res.request_id === this.$store.state.tasksDetailsRequestId) &&
        window.location.pathname.includes("/admin") &&
        this.$store.state.openTasksDetailsRequestSection;

      if (
        isStatusOpenRequest ||
        isMatchingPath ||
        isMatchingRequestTasksPath ||
        isMatchingRequestTasksDetailsPath
      ) {
        return "openRequest";
      }
    },

    slotName(field) {
      return `item.${field.value}`;
    },
    refresh() {
      this.page = 1;
      this.$emit("refresh");
    },

    updateTempCounterOfShow(newValue) {
      this.tempCounterOfShow = Number(newValue);
    },
    updateCounterOfShow() {
      this.$store.state.counterOfShow = this.tempCounterOfShow;
    }
    
  },
  created() {
    this.page = 1;

    this.calculateSumSources();
    //this.calculateSum();
    //   this.calculateMortgageSum();
    this.calculateSumV3();


  },
};
</script>
<style lang="scss">
.openRequest {
  background-color: #f5c4c6 !important;
}

.oddRowcolor {
  background: #e3dce3 !important;
}

.v-application .elevation-1 {
  background: #ffffff 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 12px 24px #12263f08 !important;
  border: 1px solid #e2e2e4 !important;
  border-radius: 3px !important;
}

.printing {
  box-shadow: 0px 12px 24px #12263f08 !important;
  border-radius: 3px !important;
  justify-content: flex-end !important;
}

.v-menu__content {
  box-shadow: 0px 10px 25px #00000026 !important;
}

.v-card {
  border-radius: unset !important;
  border: 1px solid #c9ccd2 !important;
  box-shadow: unset !important;
}

.v-data-table th {
  font-weight: bolder !important;
  font-size: 16px !important;
  color: #444444 !important;
  vertical-align: top !important;
  padding-top: 7px !important;
  background-color: #f8f9fa;
  letter-spacing: 0px;
}

.v-data-table td {
  letter-spacing: 0px;
  font-weight: 500;
  color: #5d5d5d;
  font-size: 16px !important;
}

.v-data-table tr:nth-of-type(even) {
  border-color: #f8f9fa !important;
  font-size: 16px;
  background-color: #f8f9fa;
}

.v-data-table th .v-icon {
  margin-top: -3px !important;
  margin-right: 7px !important;
  font-size: 18px !important;
}

.v-data-table__wrapper {
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
  border-left: 1px solid #e9e9e9;
}

.v-data-table thead tr:last-child > th {
  border-bottom: thin solid #e9e9e9 !important;
}

.v-data-table tr td {
  border-bottom: 1px solid #e9e9e9 !important;
}

.v-data-table tr:nth-of-type(even) {
  background-color: #f8f9fa;
}

.v-data-table tr td:last-child,
.v-data-table tr th:last-child {
  border-right: 1px solid #e2e2e2;
  // background-color: #ffffff;

  i {
    font-size: 34px;
  }

  button {
    padding: 0 !important;
  }
}

.v-data-table tr th:last-child {
  background-color: #f8f9fa;
}

@media (max-width: 990px) {
  .v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
    border-bottom: 1px solid #d1d1d1;
    padding: 17px;
  }

  .v-data-table tr td:last-child,
  .v-data-table tr th:last-child {
    border-right: 1px solid #e2e2e2;
    background-color: transparent;
  }
}

@media (max-width: 500px) {
  .v-card > *:last-child:not(.v-btn):not(.v-chip):not(.v-avatar):not(.excluded) {
    padding: 0 !important;
  }
  .v-application--is-rtl .v-data-table__mobile-row__header,
  .v-application--is-rtl .v-data-table__mobile-row__cell {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.secondary__table
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  background: var(--primary-color);
  color: white !important;
  border-right: 1px solid white;
  border-bottom: 1px solid var(--primary-color) !important;
  height: 72px;
}

.secondary__table .v-data-table-header__icon {
  display: none;
}

.secondary__table .v-data-table th .v-icon {
  color: white;
}

.secondary__table .v-data-table__wrapper {
  border-radius: 12px 12px 0 0;
}

.secondary__table .v-data-table th .v-icon {
  width: 50px;
  height: 20px;
  background: white;
  border-radius: 3px;
}

.secondary__table .v-data-table tr:nth-of-type(even) {
  background-color: #e3dce3;
}

/* Request sources summary rows (المجموع, المكررة, جديد) – same bg as table rows */
.secondary__table .v-data-table tr.request-sources-summary-row td {
  background-color: #e3dce3 !important;
}
.theme--dark .secondary__table .v-data-table tr.request-sources-summary-row td {
  background-color: rgba(255, 255, 255, 0.05) !important;
}
.dark .main__table .v-data-table tr.request-sources-summary-row td {
    background-color: #100d18 !important;
}
.secondary__table .v-input--selection-controls__input .v-icon {
  color: purple;
}

.table-toolbar .v-btn:not(.v-btn--round).v-size--small {
  color: white !important;
  margin-left: -5px;
}

.table-toolbar .v-btn__content {
  background: var(--primary-color);
  width: 36px;
  height: 36px;
  border-radius: 6px;
}

.secondary__table .v-input__slot {
  min-height: 30px !important;
  margin-top: 20px;
  border: 1px solid var(--primary-color);
}

.secondary__table .v-text-field--outlined.v-input--is-focused fieldset {
  height: 30px !important;
  border: none;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row),
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-family: "Material Design Icons";

  span {
    font-family: "Material Design Icons";
  }
}
.secondary__table .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  background-color: #e7dfe8 !important;
  color:#000 !important;    
  height: 49px !important;  
}
.secondary__table .v-data-table__wrapper {
    border-radius: 0 !important;    
}
</style>
